export default [
    {
        path: '/home-notices',
        name: 'home-notices',
        component: () => import('../../pages/homeNotices/IndexPage.vue'),
        meta: {
            title: 'Home Notices',
            requiresAuth: true,
        },
    },
]
